import { firestore as db } from "../../firebaseConfig";
import { collection, query, where,getDocs,doc ,onSnapshot, setDoc } from "firebase/firestore";

export  const getAllPlans=async()=>{
    try {
        const plans=await  getDocs(collection(db, "plans"));
        const list=[];
        plans.forEach(plan=>list.push(plan.data()));
        return list
    } catch (e) {
        // console.log(e.message);
    }
}
export const getAllmerchantsData=async()=>{
    try {
        const q =await  getDocs(collection(db, "stores"));
        let list=[]
        q.forEach(docSnap => {
            if(docSnap.exists()){
                if(docSnap.id!=="expertmin_admin"){
                    list.push({name:docSnap.id,...docSnap.data()});
                }

            }
        });
        list=list.map(i=>({
            ...i,
            createdAt:i.createdAt.toDate().toLocaleDateString(),
            endTrialDate:i.endTrialDate.toDate()?.toLocaleDateString(),
        }))
        return list
    } catch (e) {
        // console.log(e);
    }
}
export const getStoreAnalysis=async(name,callback,errHandler)=>{
    let unsub;
    try {
        const q=query(collection(db,`stores/${name}/analysis`))
        let data=[] ;
         unsub=onSnapshot(doc(db, `stores/${name}/analysis`, "allAnalysis"), (docSnap) => {
            if(docSnap.exists()){
                callback(docSnap.data()) 
            }else{
                callback({
                    totalAmount:0,
                    totalMinutes:0,
                    totalProducts:0,
                    totalQuantity:0,
                })
            }
        });
        return unsub
    } catch (e) {
        // console.log(e,"e.storeAnalysis");
        errHandler(p=>({
            ...p,
            analysis:true
        }))
        return unsub
    }
}
export const getBusinessHours=async(name,callback)=>{
    try {
        const docsSnapshot=await getDocs(collection(db, `stores/${name}/businessHours`));//query(collection(db,`registrationCode/${name}/businessHours`))
        
        let list=[]
        docsSnapshot.forEach(document=>{
            list.push(document.data());
        })
        return {data:list,error:false}
    } catch (e) {
        // console.log(e.message);
        return{data:null,error:true}
    }
}
export const getSubscriptions=async(name)=>{
    try { 
        const docsSnapshot=await getDocs(collection(db, `stores/${name}/subscription`));//query(collection(db,`registrationCode/${name}/businessHours`))
        
        let list=[]
        docsSnapshot.forEach(document=>{
            list.push(document.data());
        })
        return {data:list,error:false}
    } catch (e) {
        // console.log(e.message)
        return {data:null,error:true}
    }
}
export const collectionSnapShot=async(path)=>{
    try {
        const q = query(collection(db, path));
       const unsubscribe = onSnapshot(q, (snapshot) => {
        snapshot.forEach((change) => {
            
        });
        });
    } catch (e) {
        // console.log("error in getCollectionSnap",e);
    }
}
export const disableMerchant=async(name,action,msg)=>{
    try {
        const storeRef = doc(db, 'stores', name);
          await setDoc(storeRef, { disabled: action,disableReason:msg }, { merge: true });
          return true;
    } catch (e) {
        // console.log(e.message);
        return false
    }
}
export const getAllEmployees = async (store) => {
    try {
        const q = query(collection(db, `users`),
            where("storeName", "==", store),
        );
        const querySnapshot = await getDocs(q);
        if (querySnapshot.empty) {
            return { data: [], error: false }
        } else {
            // console.log(startDate, endDate)
            let list = []
            querySnapshot.forEach((doc) => {
                list.push(doc.data())

            })
            return { data: list, error: false }
        }
    } catch (e) {
        return { data: null, error: true }
    }
}
export const getManagementAccounts=async()=>{
    
        try {
            const collectionRef = collection(db, 'users');
            const q = query(collectionRef, where("storeName",
                "==",
                // "expertminute"
                  "expertmin_admin"
                ),
                );
            const list = [];
            const querySnapshot = await getDocs(q);
            if(querySnapshot.empty) return {data:[],error:false}
            querySnapshot.forEach((doc) => {
                list.push(doc.data())
            });
            return { data: list.filter(user => !user.deleteUser), error: null }

        } catch (e) {
            return { data: null, error: "Something went wrong" }
        }
    
}

export const getManagementAdmins=async()=>{
    try {
        const collectionRef = collection(db, 'users');
        const q = query(collectionRef, where(
            "isAdmin",
            "==",
            true
        ),
        );
        const list = [];
        const querySnapshot = await getDocs(q);
        if (querySnapshot.empty) return { data: [], error: false }
        querySnapshot.forEach((doc) => {
            list.push(doc.data())
        });
        return { data: list.filter(user => !user.deleteUser), error: null }

    } catch (e) {
        return { data: null, error: "Something went wrong" }
    }
}